import type { ReactNode } from "react";
import { NavLink, Outlet } from "react-router-dom";

import { PageHeader } from "../../layout/PageHeader";
import { cx } from "../../lib/cx";
import { settingsGroups } from "./nav";

export function SettingsLayout(): ReactNode {
  return (
    <>
      <PageHeader>
        <h1 className="text-base font-semibold">Settings</h1>
      </PageHeader>

      <div className="flex gap-8">
        <nav aria-label="Settings" className="w-52 shrink-0">
          {settingsGroups.map((group) => (
            <div key={group.name} className="mb-5">
              <h2 className="mb-1 px-2 text-xs font-semibold tracking-wide text-muted uppercase">
                {group.name}
              </h2>
              <ul className="flex flex-col gap-0.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <NavLink
                      to={link.to}
                      end={link.end ?? false}
                      className={({ isActive }) =>
                        cx(
                          "block rounded-md px-2 py-1.5 text-sm",
                          isActive
                            ? "bg-hover font-medium text-ink"
                            : "text-muted hover:bg-hover hover:text-ink",
                        )
                      }
                    >
                      {link.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </>
  );
}
